import React from "react";

function EmptyState({ icon = "📂", title = "No items found", message = "" }) {
  return (
    <div
      style={{
        color: "#6b7280",
        textAlign: "center",
        marginTop: 60,
        fontSize: 22,
        fontWeight: 500,
        opacity: 0.7,
      }}
    >
      <div style={{ fontSize: 60, marginBottom: 12 }}>{icon}</div>
      <div style={{ fontSize: 24, fontWeight: 600 }}>{title}</div>
      {message && <div style={{ fontSize: 16, marginTop: 8 }}>{message}</div>}
    </div>
  );
}

export default EmptyState;
